import { IMenuGroupEditable, IMenuGroupItemsFilters, IMenuGroupValidation } from '../types/menuGroupEdit';
import { defaulLangTextValidation } from '~/constants/main';

export const defaultMenuGroupItemsFilters: IMenuGroupItemsFilters = {
  search: {
    isFocused: false,
    value: '',
  },
};

export const defaultEditableCategory: IMenuGroupEditable = {
  name: { en: '', ar: '' },
  categories: [],
};

export const defaultValidation: IMenuGroupValidation = {
  valid: true,
  name: defaulLangTextValidation,
  categories: true,
  items: true,
};
